//The base url of the backend API
export const API_URL = process.env.REACT_APP_BACKEND_API;
export const API_PING_INTERVAL_MS = 30000;
export const CELL_REVEAL_MS = 350;
